import { useGetDepartments } from '@vindr/services/actions/department.action';
import { useDebounce } from '@vindr/utils/hooks/useDebounce';
import useRoleMemo from '@vindr/utils/hooks/useRoleMemo';
import { Select } from 'antd';
import { FormItemProps } from '../templates/FormProps';
import FormSelect from '../templates/FormSelect';
import { addToArray } from '@vindr/utils/helpers/common.helper';
import { SORT_ORDER } from '@vindr/services/constants/filter.constant';

interface Department extends FormItemProps {
  keyValue?: 'code' | 'id' | 'name';
  institution_id?: string;
  [key: string]: any;
}

const Department = ({
  name = 'department',
  label = 'Department',
  placeholder = 'Select Department',
  rules,
  multiple = false,
  required = false,
  onChange,
  keyValue = 'name',
  disabled,
  institution_id,
  ...props
}: Department) => {
  const [searchTerm, handleSearch] = useDebounce<string>();
  const { data, isInitialLoading, isRefetching } = useGetDepartments({
    limit: 10,
    offset: 0,
    active: true,
    sort_field: 'name',
    sort_order: SORT_ORDER.ASC,
    ...(institution_id && { institution_ids: addToArray(institution_id) }),
    ...(searchTerm && { name: searchTerm }),
  });

  const departments = data?.data;

  const rulesMemo = useRoleMemo({ required, rules, disabled });

  return (
    <FormSelect
      {...(multiple && { mode: 'multiple' })}
      loading={isInitialLoading || isRefetching}
      {...(onChange && { onChange })}
      {...(rules || (required && { rules: rulesMemo }))}
      {...{ name, label, placeholder, disabled, ...props }}
      onSearch={handleSearch}
      showSearch
      formProps={{
        getValueProps(value) {
          if (departments?.find((x) => x[keyValue] === value)) {
            return { value };
          }

          return null;
        },
      }}
    >
      {departments?.map((department) => (
        <Select.Option key={department.id} value={department[keyValue]}>
          {department.name}
        </Select.Option>
      ))}
    </FormSelect>
  );
};

export default Department;
